import { ListPersonGlobalSearchInfoDTO } from "@/pages/Private/redux/search/search.schema";
import {
	ContactListInfo,
	ContactListPerson,
	ContactProspect,
} from "@/pages/Private/pages/Contacts/schema/contacts";

export const toContactProspectPreview = (
	item: ListPersonGlobalSearchInfoDTO
): ContactProspect | null => {
	const p = item.prospect;

	if (!p) {
		return null;
	}

	const createdAt = new Date(item.createdAt).toISOString();
	const updatedAt = new Date(item.updatedAt).toISOString();

	// Carry the lead's list memberships (primary list + otherLists) so the lead panel can
	// resolve where it currently lives (Inbox / Outbox / List). The contact-detail endpoint
	// returns these as `sourceContexts` (without assignStatus), so the search DTO is the only
	// place that has assignStatus per list for a freshly-searched contact.
	const listPersons: ContactListPerson[] = [];
	const lists: ContactListInfo[] = [];

	if (item.list?.id) {
		listPersons.push({
			id: item.id ?? item.list.id,
			listId: item.list.id,
			assignStatus: item.assignStatus,
			createdAt,
			updatedAt,
		});
		lists.push({ id: item.list.id, name: item.list.name });
	}

	for (const other of item.otherLists ?? []) {
		if (!other.list?.id) {
			continue;
		}

		listPersons.push({
			id: other.list.id,
			listId: other.list.id,
			assignStatus: other.assignStatus,
			updatedAt,
		});
		lists.push({ id: other.list.id, name: other.list.name });
	}

	return {
		listPersons,
		lists,
		id: p.id,
		name: p.name ?? null,
		firstName: p.firstName ?? null,
		lastName: p.lastName ?? null,
		email: p.email ?? null,
		emailStatus: p.emailStatus ?? null,
		title: p.title ?? null,
		seniority: p.seniority ?? null,
		linkedinUrl: p.linkedinUrl ?? null,
		city: p.city ?? null,
		state: p.state ?? null,
		country: p.country ?? null,
		image: p.image ?? null,
		phone: p.phone ?? null,
		phoneStatus: p.phoneStatus ?? null,
		headline: p.headline ?? null,
		sentiment: p.sentiment ?? null,
		gender: p.gender ?? null,
		genderProbability: p.genderProbability ?? null,
		createdAt,
		updatedAt,
		organization: p.organization
			? ({
					id: p.organization.id,
					name: p.organization.name,
					industry: p.organization.industry ?? null,
					city: p.organization.city ?? null,
					state: p.organization.state ?? null,
					country: p.organization.country ?? null,
					estimatedNumEmployees: p.organization.estimatedNumEmployees ?? null,
					websiteUrl: p.organization.websiteUrl ?? null,
					primaryDomain: p.organization.primaryDomain ?? null,
					linkedinUrl: p.organization.linkedinUrl ?? null,
					logoUrl: p.organization.logoUrl ?? null,
					foundedYear: p.organization.foundedYear ?? null,
				} as ContactProspect["organization"])
			: null,
		scorePersonaCategoryResult: p.scorePersonaCategoryResult ?? null,
		deepResearchResponse: p.deepResearchResponse ?? null,
	};
};
